<div class="title-bar">
  <div class="search-wrap">
    <mulo-searchbar
      [label]="'research.portal.searchbar.placeholder' | translate"
      [clearInputButtonLabel]="'research.aria.search.bar.clear' | translate"
      color="none"
      size="normal"
      (searchSubmit)="goToSearch($event)"
      >
      <mulo-searchbar-options
        id="portal-entities"
        placement="after"
        [value]="activeEntity"
        [options]="searchEntities"
        (selectionChange)="handleEntityChange($event)"
        [label]="'research.aria.search.combobox.entity' | translate"
      ></mulo-searchbar-options>
      @if (searchScopesByEntity.length > 0) {
        <mulo-searchbar-options
          id="portal-scopes"
          class="scope-separator"
          placement="after"
          [value]="activeScope"
          [options]="searchScopesByEntity"
          (selectionChange)="handleScopeChange($event)"
          [label]="'research.aria.search.combobox.scope' | translate"
        ></mulo-searchbar-options>
      }
    </mulo-searchbar>
  </div>
</div>
